// Imagens abaixo da dobra só baixam quando se aproximam da tela.
//
// Por que não basta loading="lazy": no celular com rede lenta o Chrome
// dispara o lazy nativo até ~2.500px abaixo da dobra — na home isso são
// as ~100 imagens dos cards, todas disputando banda com o banner de
// abertura (medido em 29/08: LCP de 18 s cai para 5 s quando só o banner
// carrega). Aqui o card nasce com data-src/data-srcset e um pixel
// transparente; a fonte real entra a 400px de o card entrar na tela.
(() => {
  // srcset antes de src: se o src entrar primeiro o navegador pode baixar os dois
  const ATRIBUTOS = ['sizes', 'srcset', 'src'];

  function carregar(img) {
    for (const a of ATRIBUTOS) {
      const v = img.getAttribute('data-' + a);
      if (v !== null) {
        img.setAttribute(a, v);
        img.removeAttribute('data-' + a);
      }
    }
    img.classList.remove('lazy-imagem');
  }

  const alvo = 'img[data-src], img[data-srcset]';

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(alvo).forEach(carregar);
    return;
  }

  const io = new IntersectionObserver(
    (entradas) => {
      for (const e of entradas) {
        if (!e.isIntersecting) continue;
        io.unobserve(e.target);
        carregar(e.target);
      }
    },
    // 400px nos QUATRO lados, não só na vertical: os carrosséis da home são
    // horizontais (decisão comercial), e um card fora da tela pela direita
    // nunca intersecta se a margem só crescer para cima e para baixo — quem
    // arrasta veria o card chegar em branco. Com 400px laterais o carrossel já
    // traz ~2 cards adiante prontos. Medido: contra '400px 0px' a diferença de
    // LCP fica dentro do ruído (11,6 s x 13,4 s, com produção em 18,1 s).
    { rootMargin: '400px' }
  );

  function observar(raiz) {
    (raiz || document).querySelectorAll(alvo).forEach((img) => io.observe(img));
  }

  observar();
  // Estes dois eventos são do EDITOR de temas. A Section Rendering API **não
  // dispara nenhum deles** — quem injeta faz `innerHTML = ...` e pronto.
  document.addEventListener('shopify:section:load', (e) => observar(e.target));
  document.addEventListener('shopify:block:select', (e) => observar(e.target));

  // Card que chega depois, por JS.
  //
  // Medido em 02/09 na página de produto: os 8 cards de "Você também pode
  // gostar" chegavam com 16 imagens `data-src` e **zero** com src real. O
  // cliente via os cards montados e nenhuma foto — desde 29/08, quando o
  // adiamento entrou. O observador acima nunca os via porque
  // `ProductRecommendations` injeta com `this.innerHTML` (`global.js`).
  //
  // Não é só ali: renderizam card por injeção o filtro e a paginação de
  // coleção (`facets.js`), a gaveta do carrinho, a busca preditiva e o quick
  // add. Observar mutação em vez de remendar cada chamador é o que cobre os
  // cinco de uma vez — e o próximo, inclusive card injetado por app.
  //
  // O custo é proporcional ao que entrou: só há `querySelectorAll` quando um
  // elemento é inserido. Trocar atributo (`src`, `srcset`, `class`) não conta,
  // porque a observação é de `childList`, não de atributo — `carregar()` não
  // realimenta o observador.
  new MutationObserver((mutacoes) => {
    for (const m of mutacoes) {
      for (const no of m.addedNodes) {
        if (no.nodeType !== 1) continue;
        if (no.matches(alvo)) io.observe(no);
        else observar(no);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
